<template>
    <div class="container" style="max-width:800px;">
        <div class="row">
            <div class="col-6">
              <form id="fmPay" @submit.prevent="" >
                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                <input type="text" hidden class="form-control" id="UserID" placeholder="" name="UserID" v-model="globalUserID" >
                <input type="number" hidden class="form-control" placeholder="" name="ROID" v-model="ROID">
                <input type="text" hidden class="form-control" placeholder="" name="RONo" v-model="RONo">
                <div class="input-group input-group-sm mb-2">
                    <div class="input-group-prepend">
                    <span class="input-group-text" style="width:120px;">ยอดสุทธิ :</span>
                    </div>
                    <input type="text" class="form-control form-control-sm" ref="NetAmt" name="NetAmt" v-model="NetAmt" readonly>
                </div>
                <div class="input-group input-group-sm mb-1">
                    <div class="input-group-prepend">
                    <span class="input-group-text" style="width:120px;">ชำระโดย* :</span>
                    </div>
                    <select class="form-select form-select-sm" ref="PaymentID" name="PaymentID">
                        <option disabled value="">Please select one</option>
                        <option v-for="item in dataPaymentlists" :key="item.PaymentID" :value="item.PaymentID">{{ item.PaymentName }}</option>
                    </select>
                </div>
                <div class="input-group input-group-sm mb-1">
                    <div class="input-group-prepend">
                    <span class="input-group-text" style="width:120px;">อ้างอิง/เลขที่ :</span>
                    </div>
                    <input type="text" class="form-control form-control-sm" ref="PaymentRefNo" name="PaymentRefNo" v-model="PaymentRefNo" autocomplete="false" title="ข้อมูลอ้างถึงการชำระเงิน อาทิ เลขที่บัตรเครดิต">
                </div>
                <div class="input-group input-group-sm mb-2">
                    <div class="input-group-prepend">
                    <span class="input-group-text" style="width:120px;">รับเงินมา* :</span>
                    </div>
                    <input type="text" class="form-control form-control-sm" ref="RcptAmt" name="RcptAmt" v-model="RcptAmt">
                    <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" @click="afterNumpadInputAmount(NetAmt)">รับพอดี</button>
                </div>
                <div class="input-group input-group-sm mb-1">
                    <div class="input-group-prepend">
                    <span class="input-group-text" style="width:120px;">เงินทอน :</span>
                    </div>
                    <input type="text" class="form-control form-control-sm bg-warning" ref="RefundAmt" name="RefundAmt" v-model="RefundAmt" readonly>
                </div>
                <br><br>
                <!-- <button type="button" class="btn btn-outline-success" data-bs-dismiss="modal" style="width:100%;" @click="applyRcptPayment()">รับชำระเงิน</button> -->
                <button type="button" class="btn btn-outline-success" style="width:100%;" @click="applyRcptPayment()">รับชำระเงิน</button>
              </form>
            </div>
            <div class="col-6">
                <TomNumpad
                @onNumpadOKEvent="afterNumpadInputAmount"></TomNumpad>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'jquery/dist/jquery.min.js'
// Datatable Modules
// import 'datatables.net-dt/js/dataTables.dataTables'
// import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import TomNumpad from './TomNumpad'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'LabPaid3Payment',
  components: {
    TomNumpad
  },
  data () {
    return {
      ROID: 0,
      RONo: '',
      NetAmt: 0,
      RcptAmt: 0,
      RefundAmt: 0,
      PaymentRefNo: '',
      // ช่องทางรับชำระเงิน เงินสด/เครดิตการ์ด /..
      dataPaymentlists: null
    }
  },
  props: ['rowEdit'],
  mounted () {
    // ยอดที่ต้องชำระสุทธิ
    // console.log(this.rowEdit)
    this.ROID = this.rowEdit.ROID
    this.RONo = this.rowEdit.RONo
    this.NetAmt = this.rowEdit.NetAmt
    this.RcptAmt = 0
    // ช่องทางการชำระเงินฃ
    this.getData()
  },
  methods: {
    backPageAfterSave () {
      // console.log('backPageAfterSave <LabPaid3Payment>..')
      this.$emit('onBackPageAfterSaveEvent')
    },
    checkFieldsHeaderBeforeSave () {
      if (this.RcptAmt < this.NetAmt) {
        this.$refs.RcptAmt.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'จำนวนเงินรับชำระน้อยกว่ายอดต้องชำระ!', showConfirmButton: false, timer: 1500 })
        return false
      }
      return true
    },
    saveDataMasterDetail () {
      var self = this
      if (this.checkFieldsHeaderBeforeSave()) {
        // แปลงข้อมูลจากฟอร์ม
        var x = $('#fmPay').serializeArray()
        var formData = {}
        $.each(x, function (i, field) {
          $.extend(formData, { [field.name]: field.value })
        })
        // console.log(JSON.stringify(this.curRecordHd))
        // console.log(this.curRecordHd.DocDate.toISOString().slice(0, 10))
        // console.log(formData)
        // Insert/Update by call API
        $.ajax({
          type: 'POST',
          url: this.http_baseurl + 'setdata/ro_paid_insert_rcpt_masterdetail.php',
          data: { request: JSON.stringify(formData) }
        })
          .done(function (resp) {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            }).then(function (result) {
              self.backPageAfterSave()
            })
          })
          .fail(function (resp) {
            console.log(resp)
            Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
          })
      }
    },
    applyRcptPayment () {
      // LabPaid -> LabPaid1View -> LabPaid3Payment
      // <CALL SQL API>
      this.saveDataMasterDetail()
    },
    afterNumpadInputAmount (Amt) {
      this.RcptAmt = Amt
      this.RefundAmt = this.RcptAmt - this.NetAmt
    },
    getData () {
      MyApiClient.get('getdata/payment_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.dataPaymentlists = resp.data.response
        //   setTimeout(function () { $('#myRoomTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
